<template>
    <div>
        <div class="text-center mb-3">
            <img :src="logo_image_path ? logo_image_path : '/images/user-4.jpg'"
                 @click="addLogo"
                 class="img-thumbnail logo-image"
                 data-holder-rendered="true">
            <input @change="onLogoChange"
                   accept="image/*"
                   ref="logoFileInput"
                   type='file'
                   v-show="false"/>
        </div>
        <div class="form-group row">
            <label class="col-sm-5 col-lg-4 col-form-label">Name:</label>
            <div class="col-sm-7 col-lg-8">
                <input :class="{ 'parsley-error' : form.errors.has('name') }"
                       class="form-control"
                       placeholder="Enter name"
                       title="Name"
                       type="text"
                       v-model="form.name">
                <ul :class="{'filled' : form.errors.has('name')}"
                    class="parsley-errors-list">
                    <li class="parsley-required">
                        {{ form.errors.get('name') }}
                    </li>
                </ul>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-5 col-lg-4 col-form-label">Email:</label>
            <div class="col-sm-7 col-lg-8">
                <input :class="{ 'parsley-error' : form.errors.has('email') }"
                       class="form-control"
                       placeholder="Enter email"
                       title="Email"
                       type="text"
                       v-model="form.email">
                <ul :class="{'filled' : form.errors.has('email')}"
                    class="parsley-errors-list">
                    <li class="parsley-required">
                        {{ form.errors.get('email') }}
                    </li>
                </ul>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-5 col-lg-4 col-form-label">Phone number:</label>
            <div class="col-sm-7 col-lg-8">
                <input :class="{ 'parsley-error' : form.errors.has('phone_number') }"
                       class="form-control"
                       placeholder="Enter company phone number"
                       title="Phone number"
                       type="text"
                       v-model="form.phone_number">
                <ul :class="{'filled' : form.errors.has('phone_number')}"
                    class="parsley-errors-list">
                    <li class="parsley-required">
                        {{ form.errors.get('phone_number') }}
                    </li>
                </ul>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-5 col-lg-4 col-form-label">Address:</label>
            <div class="col-sm-7 col-lg-8">
                <input :class="{ 'parsley-error' : form.errors.has('address') }"
                       class="form-control"
                       placeholder="Enter company address"
                       title="Company address"
                       type="text"
                       v-model="form.address">
                <ul :class="{'filled' : form.errors.has('address')}"
                    class="parsley-errors-list">
                    <li class="parsley-required">{{
                        form.errors.get('address') }}
                    </li>
                </ul>
            </div>
        </div>
        <div v-if="!company">
            <div class="form-group row">
                <label class="col-sm-5 col-lg-4 col-form-label">Dealer Principle name:</label>
                <div class="col-sm-7 col-lg-8">
                    <input :class="{ 'parsley-error' : form.errors.has('dealer_principle.name') }"
                           class="form-control"
                           placeholder="Enter name"
                           title="Dealer principle name"
                           type="text"
                           v-model="form.dealer_principle.name">
                    <ul :class="{'filled' : form.errors.has('dealer_principle.name')}"
                        class="parsley-errors-list">
                        <li class="parsley-required">{{
                            form.errors.get('dealer_principle.name') }}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-5 col-lg-4 col-form-label">Dealer Principle email:</label>
                <div class="col-sm-7 col-lg-8">
                    <input :class="{ 'parsley-error' : form.errors.has('dealer_principle.email') }"
                           class="form-control"
                           placeholder="Enter email"
                           title="Dealer principle email"
                           type="text"
                           v-model="form.dealer_principle.email">
                    <ul :class="{'filled' : form.errors.has('dealer_principle.email')}"
                        class="parsley-errors-list">
                        <li class="parsley-required">{{
                            form.errors.get('dealer_principle.email') }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-5 col-lg-4 col-form-label">Homenet Dealer ID:</label>
            <div class="col-sm-7 col-lg-8">
                <input v-model="form.dealer_id"
                       :class="{ 'parsley-error' : form.errors.has('dealer_id') }"
                       class="form-control"
                       placeholder="Enter Homenet Dealer ID"
                       title="Homenet Dealer ID"
                       type="text">
                <ul :class="{'filled' : form.errors.has('dealer_id')}"
                    class="parsley-errors-list">
                    <li class="parsley-required">
                        {{ form.errors.get('dealer_id') }}
                    </li>
                </ul>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-5 col-lg-4 col-form-label">Automatically show vehicles after: </label>
            <div class="col-sm-7 col-lg-8">
                <input :class="{ 'parsley-error' : form.errors.has('days_in_stock') }"
                       class="form-control"
                       placeholder="Enter days in stock"
                       title="Days in stock"
                       type="number"
                       v-model="form.days_in_stock">
                <ul :class="{'filled' : form.errors.has('days_in_stock')}"
                    class="parsley-errors-list">
                    <li class="parsley-required">
                        {{ form.errors.get('days_in_stock') }}
                    </li>
                </ul>
            </div>
        </div>
        <div>
            <div class="d-flex align-items-center">
                <button :disabled="homenetForm.busy"
                        class="btn btn-primary waves-effect waves-light"
                        type="button"
                        @click="refreshHomeNetData">
                    <i class="mdi mdi-refresh"/>
                    Refresh Homenet Data
                </button>
                <div>
                    <i ref="refreshButtonPopover"
                       class="mdi mdi-help-circle-outline mdi-18px text-info ml-1"
                    />
                </div>
            </div>
            <ul v-if="homenetForm.homenetError"
                class="filled parsley-errors-list">
                <li v-if="homenetForm.homenetError.status === 404" class="parsley-required">
                    Dealer Id doesn't exist.
                </li>
                <li v-else class="parsley-required">
                    {{ homenetForm.homenetError.data }}
                </li>
            </ul>
        </div>
        <div class="form-group m-t-20">
            <div class="custom-control custom-checkbox">
                <input
                    class="custom-control-input"
                    id="is_wholesale"
                    type="checkbox"
                    v-model="form.is_wholesale"
                >
                <label class="custom-control-label" for="is_wholesale">Wholesale Account</label>
            </div>
        </div>
        <div class="mt-5 text-center">
            <button @click="goTo(Routes.company)"
                    class="btn btn-secondary waves-effect waves-light"
                    type="button">
                <i class="mdi mdi-close"/>
                Back to List
            </button>
            <button :disabled="form.busy"
                    @click="submit"
                    class="btn btn-primary waves-effect waves-light" type="button">
                <i class="mdi mdi-content-save"/>
                {{ company ? 'Save changes' : 'Submit' }}
            </button>
        </div>
    </div>
</template>

<script>
import Routes from "@/constants/routes";
import Company from "@/models/company";

export default {
    props: {
        company: {
            type: Object
        }
    },
    data() {
        let rules = {
            dealer_id: 'string|max:255',
            name: 'required|string|max:255',
            email: 'required|email',
            phone_number: 'string|max:255',
            address: 'string|max:255',
            is_wholesale: 'boolean',
            days_in_stock: 'required|integer|min:1|max:365',
        };
            if (!this.company) {
                rules['dealer_principle'] = {
                    name: 'required|string|max:255',
                    email: 'required|email|unique_email'
                }
            }
            return {
                Routes,
                form: new Form({
                    id: null,
                    dealer_id: null,
                    name: null,
                    email: null,
                    phone_number: null,
                    address: null,
                    logo: null,
                    is_wholesale: null,
                    dealer_principle: {
                        name: null,
                        email: null
                    },
                    days_in_stock: null,
                }, rules),
                logo_image_path: null,
                homenetForm: {
                    busy: false,
                    homenetError: null,
                }
            }
        },
        mounted() {
            this.$nextTick(() => {
                $(this.$refs.refreshButtonPopover).popover({
                    content: "Click to request homenet data refresh.",
                    trigger: 'hover',
                    placement: 'top'
                });
            })
            if (this.company) {
                this.form = _.extend(
                    this.form,
                    _.pick(
                        this.company,
                        ['id', 'dealer_id', 'name', 'email', 'phone_number', 'address', 'is_wholesale', 'days_in_stock']
                    )
                );
                this.logo_image_path = this.company.logo;
            }
        },
        methods: {
            addLogo() {
                this.$refs.logoFileInput.click();
            },
            onLogoChange(e) {
                if (!e.target.files.length) {
                    return;
                }
                this.form.logo = e.target.files[0];
                this.logo_image_path = URL.createObjectURL(this.form.logo);
            },
            submit() {
                this.form.validate()
                    .then(() => {
                        let company = new Company(this.form);
                        if (!this.company) {
                            company.saveData()
                                .then(() => {
                                    this.form.clearFields();
                                    this.logo_image_path = null;
                                    this.$notify({
                                        title: 'Success',
                                        message: 'Successfully created new company.',
                                        type: 'success'
                                    });
                                });
                        } else {
                            this.$confirm('Are you sure to save changes?', 'Confirm', {
                                confirmButtonText: 'OK',
                                cancelButtonText: 'Cancel',
                                type: 'info'
                            }).then(() => {
                                company.updateData()
                                    .then((response) => {
                                        this.company.dealer_id = response.data.dealer_id;

                                        this.$notify({
                                            title: 'Success',
                                            message: 'Successfully updated company.',
                                            type: 'success'
                                        });
                                    })
                            });
                        }
                    })
            },
            goTo(route_name) {
                this.$router.push({
                    name: route_name
                })
            },
            refreshHomeNetData() {
                this.homenetForm.busy = true;
                this.homenetForm.homenetError = null;
                axios.post(`/web-api/homenet/refresh`, {
                    dealer_id: [this.company.dealer_id]
                })
                    .then(() => {
                        this.$notify({
                            title: 'Success',
                            message: 'Request sent.',
                            type: 'success'
                        });
                    })
                    .catch(({response}) => {
                        this.homenetForm.homenetError = response;
                    })
                    .finally(() => {
                        this.homenetForm.busy = false;
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .logo-image {
        width: 150px;
        height: 150px;
        object-fit: cover;
        cursor: pointer;
    }
</style>
